import { useEffect, useState } from 'react'
import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import Spinner from '../Spinner/Spinner'
import { Alert } from 'reactstrap'
import PubSub from 'pubsub-js'
import { SEARCH_RESULTS_QUERY } from '../../graphql.js'
import { getLoginItem } from '../../utils'
import SearchResults from './SearchResults'
import './SearchResults.css'

const SEARCH_RESULTS = gql(SEARCH_RESULTS_QUERY)

export default function SearchResultsContainer({ match, location }) {
  console.log('SearchResultsContainer rendered')

  const params = new URLSearchParams(location.search)
  const start = params.get('start')
  const currentWorkspaceId = getLoginItem('currentWorkspaceId')
  const inputs = JSON.parse(params.get('inputs'))
  const sortColumn = params.get('sortColumn')
  const sortDir = params.get('sortDir')
  const addButton = params.get('addButton')
  const viewLink = params.get('viewLink')

  const [refresh, refreshSearchResults] = useState(new Date())

  const { loading, error, data } = useQuery(SEARCH_RESULTS, {
    variables: {
      id: match.params.id,
      start: parseInt(start),
      workspaceId: currentWorkspaceId,
      inputs: inputs,
      sortColumn: sortColumn,
      sortDir: sortDir
    }
  })

  useEffect(() => {
    function handleRefresh(msg, data) {
      console.log(`EVENT RECEIVED (SearchResultsContainer): ${msg}`, data)
      if (refresh) {
        refreshSearchResults(new Date())
        window.location.reload()
      }
    }
    const token = PubSub.subscribe('REFRESH SEARCH RESULTS', handleRefresh)
    return function cleanup() {
      PubSub.unsubscribe(token)
    }
  })

  if (error) {
    console.log(`Search: ${error.message}`)
    return <Alert className="search-results-alert" color="danger">{error.message}</Alert>
  }
  if (loading) {
    return <Spinner />
  }
  if (data.searchResults) {
    let hasSubtotal = false
    for (let column of data.searchResults.details) {
      if (column.subtotal === 'Y') {
        hasSubtotal = true
      }
    }
    return (
      <SearchResults
        searchResults={data.searchResults}
        inputs={inputs}
        lastColumnSorted={sortColumn}
        sortDir={sortDir}
        addButton={addButton}
        viewLink={viewLink}
        hasSubtotal={hasSubtotal}
      />
    )
  } else {
    return ''
  }
}
